import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader, ScrollToTop } from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { Box, Button, Divider, Paper, Snackbar, Alert, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import { Col, Row, Form } from "react-bootstrap";

const UbahLaporanPolisi = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.pathname.split("/")[2];
  const [values, setValues] = useState({ tglLaporanPolisi: "", noJual: "", keterangan: "" });
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFetchError, setIsFetchError] = useState(false);
  const textRight = { textAlign: screenSize >= 650 ? "right" : undefined };
  const authBody = { id: user._id, token: user.token, kodeCabang: user.cabang ? user.cabang._id : undefined };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(tempUrl + "/laporanPolisis/" + id, authBody);
        const row = response.data;
        setValues({
          tglLaporanPolisi: row.tglLaporanPolisi ? String(row.tglLaporanPolisi).split("T")[0] : "",
          noJual: row.noJual || "",
          keterangan: row.keterangan || "",
        });
      } catch (requestError) {
        if (requestError.response && requestError.response.status === 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        } else {
          setIsFetchError(true);
        }
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [id]);

  const updateData = async (event) => {
    event.preventDefault();
    if (!values.tglLaporanPolisi || !values.noJual.trim() || !values.keterangan.trim()) {
      setValidated(true);
      setError("Tanggal, No. Jual, dan keterangan wajib diisi.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(tempUrl + "/updateLaporanPolisi/" + id, {
        ...values,
        noJual: values.noJual.trim(),
        keterangan: values.keterangan.trim(),
        ...authBody,
      });
      navigate("/laporanPolisi/" + id);
    } catch (requestError) {
      if (requestError.response && requestError.response.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      } else {
        setError(requestError.response && requestError.response.data && requestError.response.data.message || "Gagal mengubah data.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;
  if (isFetchError) return <FetchErrorHandling />;
  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>Ubah Laporan Polisi</Typography>
      <Divider sx={dividerStyle} />
      <Paper sx={contentContainer} elevation={12}>
        <Form noValidate validated={validated} onSubmit={updateData}>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Tanggal LP :</Form.Label>
                <Col sm="8"><Form.Control required type="date" value={values.tglLaporanPolisi} onChange={(event) => setValues({ ...values, tglLaporanPolisi: event.target.value })} /></Col>
              </Form.Group></Col></Row>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>No. Jual :</Form.Label>
                <Col sm="8"><Form.Control required value={values.noJual} onChange={(event) => setValues({ ...values, noJual: event.target.value })} /></Col>
              </Form.Group></Col></Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Keterangan :</Form.Label>
                <Col sm="8"><Form.Control required as="textarea" rows={4} value={values.keterangan} onChange={(event) => setValues({ ...values, keterangan: event.target.value })} /></Col>
              </Form.Group></Col></Row>
            </Box>
          </Box>
          <Box sx={buttonContainer}>
            <Button variant="outlined" color="secondary" onClick={() => navigate("/laporanPolisi/" + id)} sx={{ marginRight: 2 }}>{"< Kembali"}</Button>
            <Button variant="contained" startIcon={<EditIcon />} type="submit">Ubah</Button>
          </Box>
        </Form>
      </Paper>
      <Snackbar open={Boolean(error)} autoHideDuration={5000} onClose={() => setError("")}><Alert severity="error">{error}</Alert></Snackbar>
    </Box>
  );
};

export default UbahLaporanPolisi;

const subTitleText = { fontWeight: "900" };
const dividerStyle = { pt: 4 };
const contentContainer = { mt: 4, p: 4 };
const showDataContainer = { display: "flex", flexDirection: { xs: "column", sm: "row" } };
const showDataWrapper = { display: "flex", flex: 1, flexDirection: "column", maxWidth: { md: "40vw" } };
const secondWrapper = { marginLeft: { sm: 4 }, marginTop: { sm: 0, xs: 4 } };
const buttonContainer = { mt: 3, display: "flex", justifyContent: "center" };
